import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Plus, FileText, ClipboardList } from 'lucide-react'
import Popup from 'components/Popup'
import Layout from 'components/Layout/Layout'
import SiteDetailTemplatesSelect from 'components/Sidebars/SiteDetailTemplatesSelect'
import ListAction from 'features/Actions/components/ListAction'
import EmptyLogo from 'images/empty_folder.png'
import UnderConstruction from 'images/under-construction-5.png'
import Spinner from 'components/Spinner'
import DetailsTemplate from 'features/Details'
import { useDetails } from 'features/Details/DetailsContext'

import {
	createSiteDetail,
	getSiteDetails,
	updateSiteDetail,
	loadTemplateIntoSiteDetails,
} from 'slices/siteDetailsSlice'
import { initializeTemplates } from 'slices/templateSlice'
import DetailAddPopup from 'components/popups/DetailAddPopup'
import Placeholder from 'components/Placeholder'

const SiteDetailsTemplate = ({ user }) => {
	const dispatch = useDispatch()

	const userId = user._id

	const {
		state: { openPopup, openDeletePopup, popupTitle, recordForEdit, deleteDetail },
		actions: { setOpenPopup, setOpenDeletePopup, setPopupTitle, setRecordForEdit, setDeleteDetail },
	} = useDetails()

	const [openNewDetailPopup, setOpenNewDetailPopup] = useState(false)
	const [openTemplatePopup, setOpenTemplatePopup] = useState(false)

	// const siteDetailsSelector = useSelector(state => state.siteDetails)
	// const { siteDetails, loading: isSiteDetailsLoading, isInitialized } = siteDetailsSelector

	const {
		entities: templateEntities,
		ids: templateIds,
		isInitialized: templatesInitialized,
	} = useSelector(state => state.templates)
	const newTemplates = templateIds.map(id => templateEntities[id])
	const siteDetailTemplates = newTemplates.filter(item => item.templateType !== 'task')

	useEffect(() => {
		// if (!isInitialized) {
		// 	dispatch(getSiteDetails({ projectId }))
		// }
		dispatch(initializeTemplates())
	}, [dispatch, userId])

	const addDetail = async (siteDetail, resetForm) => {
		const detailLabel = siteDetail.detailLabel
		const description = siteDetail.description
		const detailType = siteDetail.detailType
		const detail = siteDetail.detail

		await dispatch(
			createSiteDetail({
				// packageid: locationId,
				// projectid: projectId,
				packageType: 'location',
				detailLabel,
				description: description,
				detail: detail,
				detailType: detailType,
				detailTextValue: detailType === 'Text' ? detail : null,
				detailNumericValue: detailType === 'Number' ? detail : null,
				detailCurrencyValue: detailType === 'Currency' ? detail : null,
				detailDateValue: detailType === 'Date' ? detail : null,
			}),
		)

		// dispatch(
		// 	patchLocation({ locationId: locationId, updates: { updateNote: 'New Detail(s) Added' } }),
		// )
		// dispatch(patchProject({ projectId: projectId, updates: { updateNote: 'New Detail(s) Added' } }))

		// dispatch(getSiteDetails({ projectId }))

		resetForm()
		setOpenPopup(false)
		setOpenNewDetailPopup(false)
		setOpenTemplatePopup(false)
		setRecordForEdit(null)
	}

	const handleEditDeleteDetail = async (siteDetail, resetForm) => {
		const detailLabel = siteDetail.detailLabel
		const description = siteDetail.description
		const detailType = siteDetail.detailType
		const detail = siteDetail.detail

		await dispatch(
			updateSiteDetail({
				_id: siteDetail._id,
				// packageid: locationId,
				// projectid: projectId,
				packageType: 'location',
				userid: userId,
				detailLabel,
				description: description,
				detail: detail,
				detailType: detailType,
				detailTextValue: detailType === 'Text' ? detail : null,
				detailNumericValue: detailType === 'Number' ? detail : null,
				detailCurrencyValue: detailType === 'Currency' ? detail : null,
				detailDateValue: detailType === 'Date' ? detail : null,
			}),
		)

		// dispatch(
		// 	patchLocation({
		// 		locationId: locationId,
		// 		updates: { updateNote: 'Details(s) Deleted' },
		// 	}),
		// )
		// dispatch(patchProject({ projectId: projectId, updates: { updateNote: 'Detail(s) Deleted' } }))

		// dispatch(getSiteDetails({ projectId }))

		resetForm()
		setOpenPopup(false)
		setOpenNewDetailPopup(false)
		setOpenTemplatePopup(false)
		setRecordForEdit(null)
	}

	const handleTemplateLoad = async (templateId, resetForm) => {
		const template = {
			userId: userId,
			// packageid: locationId,
			// projectid: projectId,
			packageType: 'location',
			templateId: templateId,
		}

		await dispatch(loadTemplateIntoSiteDetails(template))

		resetForm()
		setOpenTemplatePopup(false)

		// dispatch(getSiteDetails({ projectId }))
	}

	const handleAddDetail = () => {
		const newDetail = {
			_id: 0,
			detailLabel: '',
			description: '',
			detailType: '',
			detail: '',
		}
		setPopupTitle('New Detail')
		setRecordForEdit(newDetail)
		setOpenNewDetailPopup(true)
	}

	const handleAddTemplate = () => {
		setPopupTitle('New Template')
		setRecordForEdit({})
		setOpenTemplatePopup(true)
	}

	// TODO: Create skeleton loader
	// if (isLocationLoading || isSiteDetailsLoading) return <Spinner containerHeight="50vh" />

	return (
		<div className="grid grid-cols-12 gap-6">
			<div className="col-span-9">
				<Placeholder aspectRatio="16:9" isFlexColumn isTransparent>
					<div>
						<img className="max-w-[360px] max-h-[360px] pt-16" src={UnderConstruction} alt="" />
					</div>
					<h2 className="pt-8 text-lg font-semibold text-[#0080fe]">
						A new and friendlier version of our Templates Builder is coming soon.
					</h2>
				</Placeholder>

				{/* <DetailsTemplate handleSubmit={handleEditDeleteDetail} /> */}
			</div>
			<div className="col-span-3">
				<Layout.SidebarItem title="Actions" hasNoMaxHeight>
					<ul>
						<li className="actionList__item">
							<ListAction
								handleAction={handleAddDetail}
								actionLabel={'Add New Detail'}
								actionIcon={<Plus className="w-4 h-4" />}
							/>
						</li>

						<li className="actionList__item">
							<ListAction
								handleAction={handleAddTemplate}
								actionLabel={'Detail Templates'}
								actionIcon={<FileText className="w-4 h-4" />}
							/>
						</li>
					</ul>
				</Layout.SidebarItem>
			</div>
			{openNewDetailPopup ? (
				<Popup
					title={popupTitle}
					openPopup={openNewDetailPopup}
					setOpenPopup={setOpenNewDetailPopup}
					isFullWidth={false}
					icon={<ClipboardList className="w-5 h-5" />}
					description="Manage site detail template"
				>
					<DetailAddPopup recordForEdit={recordForEdit} addDetail={addDetail} />
				</Popup>
			) : null}

			{openTemplatePopup ? (
				<Popup
					title="Site Detail Templates"
					openPopup={openTemplatePopup}
					setOpenPopup={setOpenTemplatePopup}
					icon={<ClipboardList className="w-5 h-5" />}
					description="Manage site detail template"
				>
					<SiteDetailTemplatesSelect
						detailTemplates={siteDetailTemplates}
						handleTemplateLoad={handleTemplateLoad}
					/>
				</Popup>
			) : null}
		</div>
	)
}

export default SiteDetailsTemplate
